import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Best coding headphones: Bose QuietComfort 35",
  "description": "",
  "published": "2017-07-19T00:00:00.000Z",
  "redirect_from": ["/blog/best-coding-headphones-bose-quietcomfort-35/swizec/7712"],
  "categories": "Opinions, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "IGHjijemjgQ",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`When looking for coding headphones, I care about two things:`}</p>
    <ol>
      <li parentName="ol">{`I want to feel like I am alone in the universe and no other humans exist`}</li>
      <li parentName="ol">{`Comfortable enough to wear all day`}</li>
    </ol>
    <p>{`I judge comfort both on how headphones feel on my ears/face and whether I have to keep them so loud that my ears hurt after a while.`}</p>
    <p>{`So far my answer has been a pair of Beats Studio. They worked great, made me feel alone in the universe, and were comfortable enough to wear all day. The cable was annoying but okay. It became super annoying after `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/first-day-new-2017-macbook-pro/swizec/7643"
      }}>{`Apple moved their headphone port to the right.`}</a></p>
    <p>{`After about 2 years of constant use, my Beats kicked the can.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Confirmed. After about 2.5 years of everyday all day use, my Beats are on their way out. 😭`}<br parentName="p"></br><br parentName="p"></br>{`And I can't solder like @m1hah suggested. `}<a parentName="p" {...{
          "href": "https://t.co/lMRelLNbsd"
        }}>{`pic.twitter.com/lMRelLNbsd`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/885974627180175360"
      }}>{`July 14, 2017`}</a></blockquote>
    <p>{`Looking for a replacement, everyone suggested `}<a parentName="p" {...{
        "href": "https://www.amazon.com/gp/product/B01E3SNO1G/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01E3SNO1G&linkCode=as2&tag=ageewitahat-20&linkId=e2da7ce562847b54253ae445a5afa79b"
      }}>{`Bose QuietComfort 35`}</a>{`. And hot damn were they right! These things are amazing.`}</p>
    <p>{`You put them on and the world disappears. You are alone. Think your thinks, code your code. Open office no more. Coworkers don't exist. If someone wants your attention they have to get up and come tap you on the shoulder.`}</p>
    <p>{`You won't know they're there and you'll do a startle and shit your pants. Worth it.`}</p>
    <p>{`I find the padding on the Bose QuietComforts a bit less comfortable than the Beats Studio, but they are a lot lighter. Never realized how heavy my Beats were until I tried these. Bose also packs smaller than Beats which is great. Bulky headphones are a pain in the arse to transport, and at $440 you're not gonna have multiple pairs.`}</p>
    <p><em parentName="p">{`You`}</em>{` might. Too rich for `}<em parentName="p">{`my`}</em>{` blood 😅`}</p>
    <p>{`Oh and the QuietComfort sound better than Beats. Yes the Beats has more bass and that makes the sound richer, but Bose sounds more real somehow. You listen to a video or a game and it sounds `}<em parentName="p">{`real`}</em>{`. Like it's not coming out of headphones at all.`}</p>
    <p>{`Sometimes I look around in surprise because I can't tell if sounds are in real life or in the video. It's great.`}</p>
    <p>{`Shout at me on Twitter if you think I'm wrong.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      